var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83342 6.66634V5.83301M8.83342 10.4163V9.58301M8.83342 14.1663V13.333M4.83341 3.33301H16.1667C17.1002 3.33301 17.5669 3.33301 17.9234 3.51466C18.237 3.67445 18.492 3.92942 18.6518 4.24302C18.8334 4.59954 18.8334 5.06625 18.8334 5.99967V7.08301C17.2226 7.08301 15.9167 8.38884 15.9167 9.99967C15.9167 11.6105 17.2226 12.9163 18.8334 12.9163V13.9997C18.8334 14.9331 18.8334 15.3998 18.6518 15.7563C18.492 16.0699 18.237 16.3249 17.9234 16.4847C17.5669 16.6663 17.1002 16.6663 16.1667 16.6663H4.83342C3.89999 16.6663 3.43328 16.6663 3.07676 16.4847C2.76316 16.3249 2.50819 16.0699 2.3484 15.7563C2.16675 15.3998 2.16675 14.9331 2.16675 13.9997V12.9163C3.77758 12.9163 5.08341 11.6105 5.08341 9.99967C5.08341 8.38884 3.77758 7.08301 2.16675 7.08301V5.99967C2.16675 5.06625 2.16675 4.59954 2.3484 4.24302C2.50819 3.92942 2.76316 3.67445 3.07676 3.51466C3.43328 3.33301 3.89999 3.33301 4.83341 3.33301Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket1);
export default __webpack_public_path__ + "static/media/ticket-1.b1318e5c4904d7c083fb4e3c17b386c7.svg";
export { ForwardRef as ReactComponent };